module.exports = __webpack_public_path__ + "media/images/icons/apple-touch-icon-precomposed-bd27109cc31925e1292203fd5edb9709.png";